<div style="background-color: #dedede;line-height: 0px;">
  <ol class="breadcrumb breadcrumb_cstm" style="background: transparent;
              font-size: 12px;margin-bottom: 0 !important;">
    <li class="breadcrumb-item item" *ngFor="let item of breadcrumbsArray; let i = index">
      <a (click)="goToPageLink(item)">
        {{ item }}
      </a>
    </li>
  </ol>
</div>
  <mat-toolbar class="top_headerbar">
    <h6 class="show-title">All Groups</h6>
    <div class="all_action_btns">
        <div class="input-group search_with_filter">
          <div class="input-group-btn search-panel">
            <button mat-button [matMenuTriggerFor]="menu"><i class="material-icons">sort_by_alpha</i> Sort</button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item>Item 1</button>
              <button mat-menu-item>Item 2</button>
            </mat-menu>
          </div>

          <div class="input-group-btn search-panel">
            <button mat-button [matMenuTriggerFor]="menu"><i class="material-icons">filter_list</i> Filter</button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item>Item 1</button>
              <button mat-menu-item>Item 2</button>
            </mat-menu>
          </div>
          <input type="hidden" name="search_param" value="all" id="search_param">
          <input type="text" class="form-control search_input" name="x" placeholder="Search term...">
        </div>
    </div>
  </mat-toolbar>


  <div class="list-box-one manager_client_list" fxLayout fxLayout.xs="column" fxLayoutGap="10px" fxLayoutGap.xs="0"
    *ngFor="let clients of clientList;let idx = index;">
    <div class="box1" fxFlex="85%">
        <div class="select_icon">
          <i style="color: #21b51d;" class="material-icons" *ngIf="clients.checked">
            check_circle_outline
          </i>
        </div>
        <div (click)="selectListItem(idx, clients.id)">
          <h4 class="header-layout">Site Name</h4>
          <span class="subheader-layout">Group Name</span>
        </div>
    </div>
    <div fxFlex="15%" class="box2">
      <div class="align-txt-center" fxFlex="50%">
        <button mat-button (click)="editGroup()"><i class="material-icons icon-orange-color">edit</i></button>
      </div>
      <div class="align-txt-center" fxFlex="50%">
        <button mat-button><i class="material-icons icon-orange-color">delete</i></button>
      </div>
    </div>
  </div>